module.exports = __webpack_public_path__ + "static/Google_Arts_And_Culture-20480d2bf8232792632a6f17d3e5f21f.mp4";